import L from "leaflet";
import pinGray from "./../images/maps-pin-gray.png";
import pinGray2x from "./../images/maps-pin-gray@2x.png";
import pinYellow from "./../images/maps-pin-yellow.png";
import pinYellow2x from "./../images/maps-pin-yellow@2x.png";
import pinRed from "./../images/maps-pin-red.png";
import pinRed2x from "./../images/maps-pin-red@2x.png";
import pinGreen from "./../images/maps-pin-green.png";
import pinGreen2x from "./../images/maps-pin-green@2x.png";
import pinBlue from "./../images/maps-pin-blue.png";
import pinBlue2x from "./../images/maps-pin-blue@2x.png";
import pinEditGray from "./../images/maps-pin-edit-gray.png";
import pinEditGray2x from "./../images/maps-pin-edit-gray@2x.png";
import pinEditYellow from "./../images/maps-pin-edit-yellow.png";
import pinEditYellow2x from "./../images/maps-pin-edit-yellow@2x.png";
import pinEditRed from "./../images/maps-pin-edit-red.png";
import pinEditRed2x from "./../images/maps-pin-edit-red@2x.png";
import pinEditGreen from "./../images/maps-pin-edit-green.png";
import pinEditGreen2x from "./../images/maps-pin-edit-green@2x.png";
import pinEditBlue from "./../images/maps-pin-edit-blue.png";
import pinEditBlue2x from "./../images/maps-pin-edit-blue@2x.png";

export var greyIcon = L.icon({
  iconUrl: pinGray,
  iconRetinaUrl: pinGray2x,
  iconSize: [24, 24],
  iconAnchor: [12, 12],
});

export var greenIcon = L.icon({
  iconUrl: pinGreen,
  iconRetinaUrl: pinGreen2x,
  iconSize: [24, 24],
  iconAnchor: [12, 12],
});

export var redIcon = L.icon({
  iconUrl: pinRed,
  iconRetinaUrl: pinRed2x,
  iconSize: [24, 24],
  iconAnchor: [12, 12],
});

export var blueIcon = L.icon({
  iconUrl: pinBlue,
  iconRetinaUrl: pinBlue2x,
  iconSize: [24, 24],
  iconAnchor: [12, 12],
});

export var yellowIcon = L.icon({
  iconUrl: pinYellow,
  iconRetinaUrl: pinYellow2x,
  iconSize: [24, 24],
  iconAnchor: [12, 12],
});

export var greyPin = L.icon({
  iconUrl: pinEditGray,
  iconRetinaUrl: pinEditGray2x,
  iconSize: [24, 32],
  iconAnchor: [12, 32],
});

export var greenPin = L.icon({
  iconUrl: pinEditGreen,
  iconRetinaUrl: pinEditGreen2x,
  iconSize: [24, 32],
  iconAnchor: [12, 32],
});

export var redPin = L.icon({
  iconUrl: pinEditRed,
  iconRetinaUrl: pinEditRed2x,
  iconSize: [24, 32],
  iconAnchor: [12, 32],
});

export var bluePin = L.icon({
  iconUrl: pinEditBlue,
  iconRetinaUrl: pinEditBlue2x,
  iconSize: [24, 32],
  iconAnchor: [12, 32],
});

export var yellowPin = L.icon({
  iconUrl: pinEditYellow,
  iconRetinaUrl: pinEditYellow2x,
  iconSize: [24, 32],
  iconAnchor: [12, 32],
});

export const iconSwitch = (sensor, draggable) => {
  var icon = draggable ? greyIcon : greyPin;
  if (sensor.period === "now" && sensor.status !== "onNoData") {
    switch (sensor.soilMoistureStatus) {
      case "aboveFieldCapacity":
        icon = draggable ? bluePin : blueIcon;
        break;
      case "belowRefillPoint":
        icon = draggable ? redPin : redIcon;
        break;
      case "normal":
        icon = draggable ? greenPin : greenIcon;
        break;
      case "belowWarningPoint":
        icon = draggable ? yellowPin : yellowIcon;
        break;
      default:
        break;
    }
  }
  return icon;
};
